<template>
    <div class="col-12 p-0 row m-0">
        <div class="form-group col-2">
            <label class="vs-input--label">fechaEvento:</label>
            <datepicker placeholder="fechaEvento" :language="lang_es"
                v-model.lazy="eventoSubsecuente.fechaEvento" format="yyyyMMdd"
                @keyup="$emit('update',eventoSubsecuente)" />
        </div>
        <div class="form-group col-3">
            <label>objetoEvento:</label>
            <vs-select class="w-full" v-model.lazy="eventoSubsecuente.objetoEvento"
                @keyup="$emit('update',eventoSubsecuente)">
                <vs-select-item value="501" text="501 - Depósito no acreditado"/>
                <vs-select-item value="502" text="502 - Pago no acreditado"/>
                <vs-select-item value="503" text="503 - Error en la cantidad de dinero recibido"/>
                <vs-select-item value="504" text="504 - Error en la cantidad de dinero transferida"/>
                <vs-select-item value="505" text="505 - Cobro de comisión o comisiones no reconocidas"/>
                <vs-select-item value="506" text="505 - Cobro de intereses no reconocidos"/>
                <vs-select-item value="507" text="507 - Devolución no aplicada"/>
                <vs-select-item value="599" text="599 - Por definir" selected/>
            </vs-select>
        </div>
        <div class="form-group col-3">
            <label>canalOperacion:</label>
            <vs-select class="w-full" v-model.lazy="eventoSubsecuente.canalOperacion"
                @keyup="$emit('update',eventoSubsecuente)">
                <vs-select-item value="601" text="601 - Aplicación móvil"/>
                <vs-select-item value="602" text="602 - Operaciones por internet:"/>
                <vs-select-item value="603" text="603 - Movimientos generados por la Institución"/>
                <vs-select-item value="699" text="699 - Por definir" selected/>
            </vs-select>
        </div>
        <div class="form-group col-3">
            <label for="importeValorizadoMonedaNacional">importeValorizadoMonedaNacional:</label>
            <vs-input type="number" name="" class="w-full" placeholder=""
                v-model.lazy="eventoSubsecuente.importeValorizadoMonedaNacional"
                @keyup="$emit('update',eventoSubsecuente)"/>
        </div>
        <div class="form-group col-1">
            <vs-button color="danger" icon="delete" size="normal" @click="$emit('remove',eventoSubsecuente)"></vs-button>
        </div>
    </div>
</template>

<script lang="js">
    import {
        es
    } from "vuejs-datepicker/dist/locale";
    import Datepicker from "vuejs-datepicker";
    export default {
        name: 'eventos-subsecuentes',
        components: {
            Datepicker,
        },
        props: {
            eventoSubsecuente: Object,
        },
        created() {},
        beforeMount() {
            // this.detalleEventoOriginaReclamacion = eventoSubsecuente;
        },
        mounted() {},
        data() {
            return {
                // detalleEventoOriginaReclamacion: {
                //     fechaEvento: '',
                //     objetoEvento: 599,
                //     canalOperacion: 699,
                //     importeValorizadoMonedaNacional: ''
                // }
                lang_es: es,
            }
        },
        methods: {},
        computed: {},
    }
</script>

<style scoped lang="scss">
</style>